import APIClient from '@/shared/http/clients/api'

const APIPci = process.env.APIBaseURLPci
const resourceName = 'COPModelo'

const GetAll = (companyId, data = {}, config = {}) => APIClient.get(`${APIPci}/${resourceName}/${companyId}`, data, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APIPci}/${resourceName}`, data, config)
const Delete = (companyId, id, data = {}, config = {}) => APIClient.delete(`${APIPci}/${resourceName}/${companyId}/${id}`, data, config)
const SpreadInsert = (id, data = {}, config = {}) => APIClient.post(`${APIPci}/${resourceName}/propagar/${id}`, data, config)

const COPTypeRepository = {
  GetAll,
  Create,
  Update,
  Delete,
  SpreadInsert
}

export default COPTypeRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/pci/coptype.js